import { combineReducers } from 'redux';

import { reducer as stats } from './statsModule';

export default combineReducers({
	stats,
});
